import { render, staticRenderFns } from "./ResultMsgModal.vue?vue&type=template&id=10ada5c2&"
import script from "./ResultMsgModal.vue?vue&type=script&lang=js&"
export * from "./ResultMsgModal.vue?vue&type=script&lang=js&"
import style0 from "./ResultMsgModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports